window.Form = function()
{
    let self            = this;
    let $form           = $('.js-contact-form');
    let $form_success   = $('.js-contact-success');
    let $form_error     = $('.js-contact-error');
    let $recaptcha      = $('.js-recaptcha');

    self.init = function()
    {
        $form.submit(self.submitForm);
        $form.find('input').on('change keyup keydown', self.showRecaptcha);
    };

    /**
     * Show the recaptcha only when typing or changing the input
     *
     * @author Rick van der Burg <rick@pixcero.nl>
     * @return void
     */
    self.showRecaptcha = function()
    {
        $recaptcha.removeClass('hide');
    };

    /**
     * Submit the form after submitting the button
     * @param e
     * @author Rick van der Burg <rick@pixcero.nl>
     * @return void
     */
    self.submitForm = function (e)
    {
        self.resetForm();
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize()
        })
            .done(self.formSuccess)
            .fail(self.formFailed);
    };

    /**
     * Reset the form
     * @author Rick van der Burg <rick@pixcero.nl>
     */
    self.resetForm = function()
    {
        $form_error.addClass('hide');
        $form_error.html('');
    };

    /**
     * After form submit, everything is alright, show success
     * @author Rick van der Burg <rick@pixcero.nl>
     * @param response
     */
    self.formSuccess = function(response)
    {
        $form_success.removeClass('hide');
        $form.slideUp();
    };

    /**
     * Form has given a 400 status error, show errors
     * @param data
     * @author Rick van der Burg <rick@pixcero.nl>
     */
    self.formFailed = function (data)
    {
        $form_error.removeClass('hide');
        // If the status is 400
        if(data.status === 400) {
            for(let error in data.responseJSON.errors) {
                $form_error.append(data.responseJSON.errors[error] + '<br>');
            }
        } else {
            $form_error.append($form_error.data('global-error'));
        }
    };
};



// WEBPACK FOOTER //
// ./scripts/components/form.js